module.exports = __webpack_public_path__ + "img/logo.f8da0e55.svg";